module.exports = __webpack_public_path__ + "static/media/vegetarian.4cd14677.jpg";